export default __webpack_public_path__ + "static/media/registerTrue.0c73006c.png";